import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyDollarSendFastSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 7.5H.835M3.75 12.5H2.5M3.75 10H1.665M2.916 15.123a4.16 4.16 0 0 0 3.75 2.377h6.667a4.167 4.167 0 0 0 4.166-4.167V6.667A4.166 4.166 0 0 0 13.333 2.5H6.666a4.16 4.16 0 0 0-3.75 2.377M10 6.25v.833M10 13.75v-.834"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.216 11.874A1.86 1.86 0 0 0 10 12.916c.916.1 1.746-.546 1.875-1.459v0c0-.63-.445-1.172-1.062-1.295l-1.626-.325A1.32 1.32 0 0 1 8.125 8.54v0A1.706 1.706 0 0 1 10 7.082a1.86 1.86 0 0 1 1.784 1.042"
    />
  </svg>
);
export default SvgCurrencyDollarSendFastSquare;
